import { Form, Button, Alert } from "react-bootstrap";
import { ShippingTypeId } from "../../actions/enums";
import { ShippingOption } from "../../tenant/tenantConfig";

interface ShippingStepProps {
  localPickup: ShippingTypeId;
  shippingOptions: ShippingOption[];
  address: string;
  city: string;
  postalCode: string;
  province: number;
  provinces: any[];
  restrictedCityError: string;
  setLocalPickup: (value: ShippingTypeId) => void;
  setAddress: (value: string) => void;
  setCity: (value: string) => void;
  setPostalCode: (value: string) => void;
  setProvince: (value: number) => void;
  handleBack: () => void;
  handleNext: () => void;
}

const ShippingStep = ({
  localPickup,
  shippingOptions,
  address,
  city,
  postalCode,
  province,
  provinces,
  restrictedCityError,
  setLocalPickup,
  setAddress,
  setCity,
  setPostalCode,
  setProvince,
  handleBack,
  handleNext,
}: ShippingStepProps) => {
  return (
    <div className="col-md-6">
      <h2>Envío o Retiro</h2>
      <Form.Group>
        <Form.Label>Formas de envío</Form.Label>
        <Form.Select
          name="local_pickup"
          id="local_pickup"
          size="lg"
          className="col-md-6 mb-2"
          value={localPickup}
          onChange={(element: any) => setLocalPickup(+element.target.value)}
        >
          <option value={ShippingTypeId.NONE}>Seleccioná una opción</option>
          {shippingOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Direccion</Form.Label>
        <Form.Control
          name="address"
          id="address"
          size="lg"
          className="col-md-6 mb-2"
          value={address}
          onChange={(element) => setAddress(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Localidad</Form.Label>
        <Form.Control
          name="city"
          id="city"
          size="lg"
          className="col-md-6 mb-2"
          value={city}
          onChange={(element) => setCity(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Codigo Postal</Form.Label>
        <Form.Control
          name="postal_code"
          id="postal_code"
          size="lg"
          className="col-md-6 mb-2"
          value={postalCode}
          onChange={(element) => setPostalCode(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Provincia</Form.Label>
        <Form.Select
          name="province"
          id="province"
          size="lg"
          className="col-md-6 mb-2"
          value={province}
          onChange={(element: any) => setProvince(+element.target.value)}
        >
          <option value="0">Seleccioná una provincia</option>
          {provinces.map((p: any, index: number) => (
            <option key={index} value={p.id}>
              {p.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <p className="text-muted">*Todos los campos son requeridos</p>
      {!!restrictedCityError && (
        <Alert variant="warning">
          <Alert.Heading>Lo sentimos</Alert.Heading>
          <p>{restrictedCityError}</p>
        </Alert>
      )}
      <div className="form-group col-md-6 mt-4 mb-2">
        <Button variant="light btn-lg me-1" onClick={handleBack}>
          Volver
        </Button>
        {!restrictedCityError && (
          <Button
            disabled={!!restrictedCityError}
            variant="secondary btn-lg w-50"
            onClick={handleNext}
          >
            Siguiente
          </Button>
        )}
      </div>
    </div>
  );
};

export default ShippingStep;
